import {
  PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR,
  PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR
} from '../../profile/constants/tag'
import { defineMessages } from 'react-intl'

export const WORKOUT_TAG = {
  ALL: 'all',
  WOMEN: 'women',
  MEN: 'men',
  CALISTHENICS: 'calisthenics',
  HYROX: 'hyrox',
  SUMMER: 'summer',
  UPPER: 'upper',
  ABS: 'abs',
  LEGS: 'legs',
  ARMS: 'arms',
  STRETCHING: 'stretching',
  FAT_LOSS: 'fat loss',
  BEGINNER: 'beginner',
  INTERMEDIATE: 'intermediate',
  ADVANCED: 'advanced',
  LISS: 'liss',
  HIIT: 'hiit',
  POWERHYBRID: 'powerhybrid',
  FULL_BODY: 'full body',
  HOME: 'home',
  DUMBBELL: 'dumbbell',
  KETTLEBELL: 'kettlebell',
  RECOVERY: 'recovery',
  PAIN_RELIEF: 'pain relief',
  RESISTANCE_BAND: 'resistance band',
  RUNNING: 'running',
  MOBILITY: 'mobility',
  TABATA: 'tabata',
  KNEE_SAFE: 'knee safe',
  HIP_SAFE: 'hip safe',
  BACK_SAFE: 'back safe',
  SHOULDER_SAFE: 'shoulder safe',
  SENIOR: 'senior',
  TRX: 'trx',
  WHEELCHAIR: 'wheelchair'
}
export const WORKOUT_TAGS = Object.values(WORKOUT_TAG)

const workoutTagMessage = defineMessages({
  all: {
    id: 'workoutTagMessage.all',
    defaultMessage: 'All'
  },
  women: {
    id: 'workoutTagMessage.women',
    defaultMessage: 'Women'
  },
  men: {
    id: 'workoutTagMessage.men',
    defaultMessage: 'Men'
  },
  summer: {
    id: 'workoutTagMessage.summer',
    defaultMessage: 'Summer'
  },
  calisthenics: {
    id: 'workoutTagMessage.calisthenics',
    defaultMessage: 'Calisthenics'
  },
  upper: {
    id: 'workoutTagMessage.upper',
    defaultMessage: 'Upper'
  },
  abs: {
    id: 'workoutTagMessage.abs',
    defaultMessage: 'Abs'
  },
  legs: {
    id: 'workoutTagMessage.legs',
    defaultMessage: 'Legs'
  },
  arms: {
    id: 'workoutTagMessage.arms',
    defaultMessage: 'Arms'
  },
  powerhybrid: {
    id: 'workoutTagMessage.powerhybrid',
    defaultMessage: 'Powerhybrid'
  },
  stretching: {
    id: 'workoutTagMessage.stretching',
    defaultMessage: 'Stretching'
  },
  fatLoss: {
    id: 'workoutTagMessage.fatLoss',
    defaultMessage: 'Fat loss'
  },
  beginner: {
    id: 'workoutTagMessage.beginner',
    defaultMessage: 'Beginner'
  },
  intermediate: {
    id: 'workoutTagMessage.intermediate',
    defaultMessage: 'Intermediate'
  },
  advanced: {
    id: 'workoutTagMessage.advanced',
    defaultMessage: 'Advanced'
  },
  liss: {
    id: 'workoutTagMessage.liss',
    defaultMessage: 'LISS'
  },
  hiit: {
    id: 'workoutTagMessage.hiit',
    defaultMessage: 'HIIT'
  },
  fullBody: {
    id: 'workoutTagMessage.fullBody',
    defaultMessage: 'Full body'
  },
  home: {
    id: 'workoutTagMessage.home',
    defaultMessage: 'Home'
  },
  dumbbell: {
    id: 'workoutTagMessage.dumbbell',
    defaultMessage: 'Dumbbell'
  },
  kettlebell: {
    id: 'workoutTagMessage.kettlebell',
    defaultMessage: 'Kettlebell'
  },
  recovery: {
    id: 'workoutTagMessage.recovery',
    defaultMessage: 'Recovery'
  },
  painRelief: {
    id: 'workoutTagMessage.painRelief',
    defaultMessage: 'Pain relief'
  },
  resistanceBand: {
    id: 'workoutTagMessage.resistanceBand',
    defaultMessage: 'Resistance band'
  },
  running: {
    id: 'workoutTagMessage.running',
    defaultMessage: 'Running'
  },
  mobility: {
    id: 'workoutTagMessage.mobility',
    defaultMessage: 'Mobility'
  },
  tabata: {
    id: 'workoutTagMessage.tabata',
    defaultMessage: 'Tabata'
  },
  kneeSafe: {
    id: 'workoutTagMessage.kneeSafe',
    defaultMessage: 'Knee safe'
  },
  hipSafe: {
    id: 'workoutTagMessage.hipSafe',
    defaultMessage: 'Hip safe'
  },
  backSafe: {
    id: 'workoutTagMessage.backSafe',
    defaultMessage: 'Back safe'
  },
  shoulderSafe: {
    id: 'workoutTagMessage.shoulderSafe',
    defaultMessage: 'Shoulder safe'
  },
  senior: {
    id: 'workoutTagMessage.senior',
    defaultMessage: 'Senior'
  },
  trx: {
    id: 'workoutTagMessage.trx',
    defaultMessage: 'TRX'
  },
  hyrox: {
    id: 'workoutTagMessage.hyrox',
    defaultMessage: 'HYROX'
  },
  wheelchair: {
    id: 'workoutTagMessage.wheelchair',
    defaultMessage: 'Wheelchair'
  }
})

export const WORKOUT_TAG_TO_MESSAGE = {
  [WORKOUT_TAG.ALL]: workoutTagMessage.all,
  [WORKOUT_TAG.WOMEN]: workoutTagMessage.women,
  [WORKOUT_TAG.MEN]: workoutTagMessage.men,
  [WORKOUT_TAG.SUMMER]: workoutTagMessage.summer,
  [WORKOUT_TAG.CALISTHENICS]: workoutTagMessage.calisthenics,
  [WORKOUT_TAG.UPPER]: workoutTagMessage.upper,
  [WORKOUT_TAG.ABS]: workoutTagMessage.abs,
  [WORKOUT_TAG.LEGS]: workoutTagMessage.legs,
  [WORKOUT_TAG.ARMS]: workoutTagMessage.arms,
  [WORKOUT_TAG.POWERHYBRID]: workoutTagMessage.powerhybrid,
  [WORKOUT_TAG.STRETCHING]: workoutTagMessage.stretching,
  [WORKOUT_TAG.FAT_LOSS]: workoutTagMessage.fatLoss,
  [WORKOUT_TAG.BEGINNER]: workoutTagMessage.beginner,
  [WORKOUT_TAG.INTERMEDIATE]: workoutTagMessage.intermediate,
  [WORKOUT_TAG.ADVANCED]: workoutTagMessage.advanced,
  [WORKOUT_TAG.LISS]: workoutTagMessage.liss,
  [WORKOUT_TAG.HIIT]: workoutTagMessage.hiit,
  [WORKOUT_TAG.FULL_BODY]: workoutTagMessage.fullBody,
  [WORKOUT_TAG.HOME]: workoutTagMessage.home,
  [WORKOUT_TAG.DUMBBELL]: workoutTagMessage.dumbbell,
  [WORKOUT_TAG.KETTLEBELL]: workoutTagMessage.kettlebell,
  [WORKOUT_TAG.RECOVERY]: workoutTagMessage.recovery,
  [WORKOUT_TAG.PAIN_RELIEF]: workoutTagMessage.painRelief,
  [WORKOUT_TAG.RESISTANCE_BAND]: workoutTagMessage.resistanceBand,
  [WORKOUT_TAG.RUNNING]: workoutTagMessage.running,
  [WORKOUT_TAG.MOBILITY]: workoutTagMessage.mobility,
  [WORKOUT_TAG.TABATA]: workoutTagMessage.tabata,
  [WORKOUT_TAG.KNEE_SAFE]: workoutTagMessage.kneeSafe,
  [WORKOUT_TAG.HIP_SAFE]: workoutTagMessage.hipSafe,
  [WORKOUT_TAG.BACK_SAFE]: workoutTagMessage.backSafe,
  [WORKOUT_TAG.SHOULDER_SAFE]: workoutTagMessage.shoulderSafe,
  [WORKOUT_TAG.SENIOR]: workoutTagMessage.senior,
  [WORKOUT_TAG.TRX]: workoutTagMessage.trx,
  [WORKOUT_TAG.HYROX]: workoutTagMessage.hyrox,
  [WORKOUT_TAG.WHEELCHAIR]: workoutTagMessage.wheelchair
}

const workoutTagTitleMessage = defineMessages({
  all: {
    id: 'workoutTagTitleMessage.all',
    defaultMessage: 'All Workouts for Every Fitness Level and Goal'
  },
  women: {
    id: 'workoutTagTitleMessage.women',
    defaultMessage: 'Workouts For Women'
  },
  men: {
    id: 'workoutTagTitleMessage.men',
    defaultMessage: 'Workouts For Men'
  },
  summer: {
    id: 'workoutTagTitleMessage.summer',
    defaultMessage: 'Summer Workouts to Get Fit for the Season'
  },
  calisthenics: {
    id: 'workoutTagTitleMessage.calisthenics',
    defaultMessage: 'Calisthenics Workouts for Strength and Flexibility'
  },
  upper: {
    id: 'workoutTagTitleMessage.upper',
    defaultMessage: 'Upper Body Workouts to Build Strength and Tone'
  },
  abs: {
    id: 'workoutTagTitleMessage.abs',
    defaultMessage: 'Ab Workouts to Build Core Strength and Stability'
  },
  legs: {
    id: 'workoutTagTitleMessage.legs',
    defaultMessage: 'Leg Workouts for Strength and Muscle Endurance'
  },
  arms: {
    id: 'workoutTagTitleMessage.arms',
    defaultMessage: 'Arm Workouts to Build Strength and Size'
  },
  powerhybrid: {
    id: 'workoutTagTitleMessage.powerhybrid',
    defaultMessage: 'Power and Hybrid Workouts for Strength and Stamina'
  },
  stretching: {
    id: 'workoutTagTitleMessage.stretching',
    defaultMessage: 'Stretching Workouts for Improved Flexibility'
  },
  fatLoss: {
    id: 'workoutTagTitleMessage.fatLoss',
    defaultMessage: 'Fat Loss Workouts to Burn Calories and Shed Pounds'
  },
  beginner: {
    id: 'workoutTagTitleMessage.beginner',
    defaultMessage: 'Beginner Workouts for Building Fitness Foundations'
  },
  intermediate: {
    id: 'workoutTagTitleMessage.intermediate',
    defaultMessage: 'Intermediate Workouts for Progressing Your Fitness'
  },
  advanced: {
    id: 'workoutTagTitleMessage.advanced',
    defaultMessage: 'Advanced Workouts for Challenging Your Limits'
  },
  liss: {
    id: 'workoutTagTitleMessage.liss',
    defaultMessage: 'LISS Workouts for Low-Impact Fat Burning'
  },
  hiit: {
    id: 'workoutTagTitleMessage.hiit',
    defaultMessage: 'HIIT Workouts for High-Intensity Fat Loss'
  },
  fullBody: {
    id: 'workoutTagTitleMessage.fullBody',
    defaultMessage: 'Full Body Workouts for Overall Strength and Fitness'
  },
  home: {
    id: 'workoutTagTitleMessage.home',
    defaultMessage: 'Home Workouts with Minimal Equipment Needed'
  },
  dumbbell: {
    id: 'workoutTagTitleMessage.dumbbell',
    defaultMessage: 'Dumbbell Workouts for Strength and Conditioning'
  },
  kettlebell: {
    id: 'workoutTagTitleMessage.kettlebell',
    defaultMessage: 'Kettlebell Workouts for Strength and Endurance'
  },
  painRelief: {
    id: 'workoutTagTitleMessage.painRelief',
    defaultMessage: 'Pain Relief Workouts to Help Muscle Stiffness and Relaxation'
  },
  recovery: {
    id: 'workoutTagTitleMessage.recovery',
    defaultMessage: 'Recovery Workouts to Aid Muscle Repair and Relaxation'
  },
  resistanceBand: {
    id: 'workoutTagTitleMessage.resistanceBand',
    defaultMessage: 'Resistance Band Workouts for Strength and Flexibility'
  },
  running: {
    id: 'workoutTagTitleMessage.running',
    defaultMessage: 'Running Workouts to Improve Speed and Stamina'
  },
  tabata: {
    id: 'workoutTagTitleMessage.tabata',
    defaultMessage: 'Tabata Workouts for Intense Conditioning'
  },
  mobility: {
    id: 'workoutTagTitleMessage.mobility',
    defaultMessage: 'Mobility Workouts for Enhanced Joint Flexibility'
  },
  kneeSafe: {
    id: 'workoutTagTitleMessage.kneeSafe',
    defaultMessage: 'Knee-Safe Workouts for Low-Impact Strength Training'
  },
  hipSafe: {
    id: 'workoutTagTitleMessage.hipSafe',
    defaultMessage: 'Hip-Safe Workouts to Avoid More Hip Pain'
  },
  backSafe: {
    id: 'workoutTagTitleMessage.backSafe',
    defaultMessage: 'Back-Safe Workouts to Protect Your Spine'
  },
  shoulderSafe: {
    id: 'workoutTagTitleMessage.shoulderSafe',
    defaultMessage: 'Shoulder-Safe Workouts to Protect Your Deltoids'
  },
  senior: {
    id: 'workoutTagTitleMessage.senior',
    defaultMessage: 'Senior Workouts Focused on Safety and Health'
  },
  trx: {
    id: 'workoutTagTitleMessage.trx',
    defaultMessage: 'TRX Suspension Training Workouts'
  },
  hyrox: {
    id: 'workoutTagTitleMessage.hyrox',
    defaultMessage: 'HYROX Functional Fitness Racing Workouts'
  },
  wheelchair: {
    id: 'workoutTagTitleMessage.wheelchair',
    defaultMessage: 'Wheelchair-Friendly Workouts for Upper Body Fitness'
  }
})

export const WORKOUT_TAG_TO_TITLE_MESSAGE = {
  [WORKOUT_TAG.ALL]: workoutTagTitleMessage.all,
  [WORKOUT_TAG.WOMEN]: workoutTagTitleMessage.women,
  [WORKOUT_TAG.MEN]: workoutTagTitleMessage.men,
  [WORKOUT_TAG.SUMMER]: workoutTagTitleMessage.summer,
  [WORKOUT_TAG.CALISTHENICS]: workoutTagTitleMessage.calisthenics,
  [WORKOUT_TAG.UPPER]: workoutTagTitleMessage.upper,
  [WORKOUT_TAG.ABS]: workoutTagTitleMessage.abs,
  [WORKOUT_TAG.LEGS]: workoutTagTitleMessage.legs,
  [WORKOUT_TAG.ARMS]: workoutTagTitleMessage.arms,
  [WORKOUT_TAG.POWERHYBRID]: workoutTagTitleMessage.powerhybrid,
  [WORKOUT_TAG.STRETCHING]: workoutTagTitleMessage.stretching,
  [WORKOUT_TAG.FAT_LOSS]: workoutTagTitleMessage.fatLoss,
  [WORKOUT_TAG.BEGINNER]: workoutTagTitleMessage.beginner,
  [WORKOUT_TAG.INTERMEDIATE]: workoutTagTitleMessage.intermediate,
  [WORKOUT_TAG.ADVANCED]: workoutTagTitleMessage.advanced,
  [WORKOUT_TAG.LISS]: workoutTagTitleMessage.liss,
  [WORKOUT_TAG.HIIT]: workoutTagTitleMessage.hiit,
  [WORKOUT_TAG.FULL_BODY]: workoutTagTitleMessage.fullBody,
  [WORKOUT_TAG.HOME]: workoutTagTitleMessage.home,
  [WORKOUT_TAG.DUMBBELL]: workoutTagTitleMessage.dumbbell,
  [WORKOUT_TAG.KETTLEBELL]: workoutTagTitleMessage.kettlebell,
  [WORKOUT_TAG.PAIN_RELIEF]: workoutTagTitleMessage.painRelief,
  [WORKOUT_TAG.RECOVERY]: workoutTagTitleMessage.recovery,
  [WORKOUT_TAG.RESISTANCE_BAND]: workoutTagTitleMessage.resistanceBand,
  [WORKOUT_TAG.RUNNING]: workoutTagTitleMessage.running,
  [WORKOUT_TAG.MOBILITY]: workoutTagTitleMessage.mobility,
  [WORKOUT_TAG.TABATA]: workoutTagTitleMessage.tabata,
  [WORKOUT_TAG.KNEE_SAFE]: workoutTagTitleMessage.kneeSafe,
  [WORKOUT_TAG.HIP_SAFE]: workoutTagTitleMessage.hipSafe,
  [WORKOUT_TAG.BACK_SAFE]: workoutTagTitleMessage.backSafe,
  [WORKOUT_TAG.SHOULDER_SAFE]: workoutTagTitleMessage.shoulderSafe,
  [WORKOUT_TAG.SENIOR]: workoutTagTitleMessage.senior,
  [WORKOUT_TAG.TRX]: workoutTagTitleMessage.trx,
  [WORKOUT_TAG.HYROX]: workoutTagTitleMessage.hyrox,
  [WORKOUT_TAG.WHEELCHAIR]: workoutTagTitleMessage.wheelchair
}

const workoutTagShortDescriptionMessage = defineMessages({
  all: {
    id: 'workoutTagShortDescriptionMessage.all',
    defaultMessage: 'All workouts, suitable for every type of training'
  },
  women: {
    id: 'workoutTagShortDescriptionMessage.women',
    defaultMessage: 'Workouts designed specifically for women’s fitness goals'
  },
  men: {
    id: 'workoutTagShortDescriptionMessage.men',
    defaultMessage: 'Workouts designed specifically for men’s fitness goals'
  },
  summer: {
    id: 'workoutTagShortDescriptionMessage.summer',
    defaultMessage: 'Ideal workouts to get fit for the summer'
  },
  calisthenics: {
    id: 'workoutTagShortDescriptionMessage.calisthenics',
    defaultMessage: 'Bodyweight workouts focusing on strength and flexibility'
  },
  upper: {
    id: 'workoutTagShortDescriptionMessage.upper',
    defaultMessage: 'Workouts targeting the upper body muscles and strength'
  },
  abs: {
    id: 'workoutTagShortDescriptionMessage.abs',
    defaultMessage: 'Effective ab workouts to build core strength'
  },
  legs: {
    id: 'workoutTagShortDescriptionMessage.legs',
    defaultMessage: 'Leg-focused workouts for strength and endurance'
  },
  arms: {
    id: 'workoutTagShortDescriptionMessage.arms',
    defaultMessage: 'Arm-focused workouts for biceps and triceps'
  },
  powerhybrid: {
    id: 'workoutTagShortDescriptionMessage.powerhybrid',
    defaultMessage: 'Combines powerlifting with hybrid training methods'
  },
  stretching: {
    id: 'workoutTagShortDescriptionMessage.stretching',
    defaultMessage: 'Stretching routines to enhance flexibility and recovery'
  },
  fatLoss: {
    id: 'workoutTagShortDescriptionMessage.fatLoss',
    defaultMessage: 'Programs focused on burning fat and losing weight'
  },
  beginner: {
    id: 'workoutTagShortDescriptionMessage.beginner',
    defaultMessage: 'Beginner-friendly workouts for those new to fitness'
  },
  intermediate: {
    id: 'workoutTagShortDescriptionMessage.intermediate',
    defaultMessage: 'Workouts designed for intermediate fitness levels'
  },
  advanced: {
    id: 'workoutTagShortDescriptionMessage.advanced',
    defaultMessage: 'Challenging workouts for advanced fitness enthusiasts'
  },
  liss: {
    id: 'workoutTagShortDescriptionMessage.liss',
    defaultMessage: 'Low-intensity steady-state cardio for sustained fat loss'
  },
  hiit: {
    id: 'workoutTagShortDescriptionMessage.hiit',
    defaultMessage: 'High-intensity interval training to maximize fat burn'
  },
  fullBody: {
    id: 'workoutTagShortDescriptionMessage.fullBody',
    defaultMessage: 'Full body workouts targeting multiple muscle groups'
  },
  home: {
    id: 'workoutTagShortDescriptionMessage.home',
    defaultMessage: 'Convenient workouts you can do from the comfort of home'
  },
  dumbbell: {
    id: 'workoutTagShortDescriptionMessage.dumbbell',
    defaultMessage: 'Dumbbell workouts focusing on strength and toning'
  },
  kettlebell: {
    id: 'workoutTagShortDescriptionMessage.kettlebell',
    defaultMessage: 'Kettlebell exercises for strength and conditioning'
  },
  painRelief: {
    id: 'workoutTagShortDescriptionMessage.painRelief',
    defaultMessage: 'Gentle workouts to aid release muscle tightness'
  },
  recovery: {
    id: 'workoutTagShortDescriptionMessage.recovery',
    defaultMessage: 'Gentle workouts to aid recovery and muscle repair'
  },
  resistanceBand: {
    id: 'workoutTagShortDescriptionMessage.resistanceBand',
    defaultMessage: 'Resistance band workouts to build strength and endurance'
  },
  running: {
    id: 'workoutTagShortDescriptionMessage.running',
    defaultMessage: 'Running programs for improving speed and endurance'
  },
  mobility: {
    id: 'workoutTagShortDescriptionMessage.mobility',
    defaultMessage: 'Workouts to enhance joint mobility and flexibility'
  },
  tabata: {
    id: 'workoutTagShortDescriptionMessage.tabata',
    defaultMessage: 'Short, high-intensity Tabata workouts for fat burn'
  },
  kneeSafe: {
    id: 'workoutTagShortDescriptionMessage.kneeSafe',
    defaultMessage: 'Knee-friendly workouts designed to minimize joint stress'
  },
  hipSafe: {
    id: 'workoutTagShortDescriptionMessage.hipSafe',
    defaultMessage: 'hip-friendly workouts built to minimize putting too much stress on your hips'
  },
  backSafe: {
    id: 'workoutTagShortDescriptionMessage.backSafe',
    defaultMessage: 'Workouts to protect and strengthen your spine'
  },
  shoulderSafe: {
    id: 'workoutTagShortDescriptionMessage.shoulderSafe',
    defaultMessage: 'Workouts to protect your shoulders and make them stronger'
  },
  senior: {
    id: 'workoutTagShortDescriptionMessage.senior',
    defaultMessage: 'Gentle and effective workouts for seniors'
  },
  trx: {
    id: 'workoutTagShortDescriptionMessage.trx',
    defaultMessage: 'Suspension training workouts using TRX straps for total body strength'
  },
  hyrox: {
    id: 'workoutTagShortDescriptionMessage.hyrox',
    defaultMessage: 'Race-specific training combining running and functional exercises'
  },
  wheelchair: {
    id: 'workoutTagShortDescriptionMessage.wheelchair',
    defaultMessage: 'Workouts adapted for those in wheelchairs'
  }
})

export const WORKOUT_TAG_TO_SHORT_DESCRIPTION_MESSAGE = {
  [WORKOUT_TAG.ALL]: workoutTagShortDescriptionMessage.all,
  [WORKOUT_TAG.WOMEN]: workoutTagShortDescriptionMessage.women,
  [WORKOUT_TAG.MEN]: workoutTagShortDescriptionMessage.men,
  [WORKOUT_TAG.SUMMER]: workoutTagShortDescriptionMessage.summer,
  [WORKOUT_TAG.CALISTHENICS]: workoutTagShortDescriptionMessage.calisthenics,
  [WORKOUT_TAG.UPPER]: workoutTagShortDescriptionMessage.upper,
  [WORKOUT_TAG.ABS]: workoutTagShortDescriptionMessage.abs,
  [WORKOUT_TAG.LEGS]: workoutTagShortDescriptionMessage.legs,
  [WORKOUT_TAG.ARMS]: workoutTagShortDescriptionMessage.arms,
  [WORKOUT_TAG.POWERHYBRID]: workoutTagShortDescriptionMessage.powerhybrid,
  [WORKOUT_TAG.STRETCHING]: workoutTagShortDescriptionMessage.stretching,
  [WORKOUT_TAG.FAT_LOSS]: workoutTagShortDescriptionMessage.fatLoss,
  [WORKOUT_TAG.BEGINNER]: workoutTagShortDescriptionMessage.beginner,
  [WORKOUT_TAG.INTERMEDIATE]: workoutTagShortDescriptionMessage.intermediate,
  [WORKOUT_TAG.ADVANCED]: workoutTagShortDescriptionMessage.advanced,
  [WORKOUT_TAG.LISS]: workoutTagShortDescriptionMessage.liss,
  [WORKOUT_TAG.HIIT]: workoutTagShortDescriptionMessage.hiit,
  [WORKOUT_TAG.FULL_BODY]: workoutTagShortDescriptionMessage.fullBody,
  [WORKOUT_TAG.HOME]: workoutTagShortDescriptionMessage.home,
  [WORKOUT_TAG.DUMBBELL]: workoutTagShortDescriptionMessage.dumbbell,
  [WORKOUT_TAG.KETTLEBELL]: workoutTagShortDescriptionMessage.kettlebell,
  [WORKOUT_TAG.PAIN_RELIEF]: workoutTagShortDescriptionMessage.painRelief,
  [WORKOUT_TAG.RECOVERY]: workoutTagShortDescriptionMessage.recovery,
  [WORKOUT_TAG.RESISTANCE_BAND]: workoutTagShortDescriptionMessage.resistanceBand,
  [WORKOUT_TAG.RUNNING]: workoutTagShortDescriptionMessage.running,
  [WORKOUT_TAG.MOBILITY]: workoutTagShortDescriptionMessage.mobility,
  [WORKOUT_TAG.TABATA]: workoutTagShortDescriptionMessage.tabata,
  [WORKOUT_TAG.KNEE_SAFE]: workoutTagShortDescriptionMessage.kneeSafe,
  [WORKOUT_TAG.HIP_SAFE]: workoutTagShortDescriptionMessage.hipSafe,
  [WORKOUT_TAG.BACK_SAFE]: workoutTagShortDescriptionMessage.backSafe,
  [WORKOUT_TAG.SHOULDER_SAFE]: workoutTagShortDescriptionMessage.shoulderSafe,
  [WORKOUT_TAG.SENIOR]: workoutTagShortDescriptionMessage.senior,
  [WORKOUT_TAG.TRX]: workoutTagShortDescriptionMessage.trx,
  [WORKOUT_TAG.HYROX]: workoutTagShortDescriptionMessage.hyrox,
  [WORKOUT_TAG.WHEELCHAIR]: workoutTagShortDescriptionMessage.wheelchair
}

const workoutTagDescriptionMessage = defineMessages({
  all: {
    id: 'workoutTagDescriptionMessage.all',
    defaultMessage: 'Explore a wide variety of workouts suitable for every fitness level and training type, ensuring there’s something for everyone.'
  },
  women: {
    id: 'workoutTagDescriptionMessage.women',
    defaultMessage: 'Workouts specifically tailored for women, focusing on fitness goals such as toning, strength, and overall health.'
  },
  men: {
    id: 'workoutTagDescriptionMessage.men',
    defaultMessage: 'Fitness programs designed for men, emphasizing muscle building, strength, and endurance to achieve optimal results.'
  },
  summer: {
    id: 'workoutTagDescriptionMessage.summer',
    defaultMessage: 'Get ready for summer with these specially curated workouts that focus on toning, fat loss, and building a lean physique.'
  },
  calisthenics: {
    id: 'workoutTagDescriptionMessage.calisthenics',
    defaultMessage: 'Engage in calisthenics routines that utilize bodyweight exercises to enhance strength, flexibility, and overall fitness.'
  },
  upper: {
    id: 'workoutTagDescriptionMessage.upper',
    defaultMessage: 'Target your upper body muscles with workouts focused on building strength and definition in your arms, chest, and shoulders.'
  },
  abs: {
    id: 'workoutTagDescriptionMessage.abs',
    defaultMessage: 'Target your core muscles with workouts focused on building strength and definition in your abs, obliques, and lower back.'
  },
  legs: {
    id: 'workoutTagDescriptionMessage.legs',
    defaultMessage: 'Strengthen your lower body with leg-focused workouts that improve muscle endurance, stability, and overall power.'
  },
  arms: {
    id: 'workoutTagDescriptionMessage.arms',
    defaultMessage: 'Build stronger arms with workouts targeting biceps, triceps, and forearms for improved strength and definition.'
  },
  powerhybrid: {
    id: 'workoutTagDescriptionMessage.powerhybrid',
    defaultMessage: 'Experience a unique blend of powerlifting and hybrid training, designed to build both strength and endurance simultaneously.'
  },
  stretching: {
    id: 'workoutTagDescriptionMessage.stretching',
    defaultMessage: 'Incorporate stretching routines into your regimen to improve flexibility, reduce muscle tension, and aid in post-workout recovery.'
  },
  fatLoss: {
    id: 'workoutTagDescriptionMessage.fatLoss',
    defaultMessage: 'Achieve your weight loss goals with these fat-burning programs, designed to optimize calorie expenditure and promote lean muscle.'
  },
  beginner: {
    id: 'workoutTagDescriptionMessage.beginner',
    defaultMessage: 'Start your fitness journey with beginner-friendly workouts that gradually build strength, endurance, and confidence in your abilities.'
  },
  intermediate: {
    id: 'workoutTagDescriptionMessage.intermediate',
    defaultMessage: 'Challenge yourself with intermediate-level workouts that provide a balanced mix of intensity and technique to elevate your fitness.'
  },
  advanced: {
    id: 'workoutTagDescriptionMessage.advanced',
    defaultMessage: 'Take your fitness to the next level with advanced workouts that push your limits, focusing on strength, power, and endurance.'
  },
  liss: {
    id: 'workoutTagDescriptionMessage.liss',
    defaultMessage: 'Engage in low-intensity steady-state (LISS) cardio workouts that are gentle on the body while effectively promoting fat loss and endurance.'
  },
  hiit: {
    id: 'workoutTagDescriptionMessage.hiit',
    defaultMessage: 'Maximize your calorie burn and improve cardiovascular fitness with high-intensity interval training (HIIT) that delivers rapid results.'
  },
  fullBody: {
    id: 'workoutTagDescriptionMessage.fullBody',
    defaultMessage: 'Perform full body workouts that engage multiple muscle groups, providing a comprehensive approach to building strength and fitness.'
  },
  home: {
    id: 'workoutTagDescriptionMessage.home',
    defaultMessage: 'Conveniently workout at home with minimal equipment, utilizing exercises that effectively target all major muscle groups.'
  },
  dumbbell: {
    id: 'workoutTagDescriptionMessage.dumbbell',
    defaultMessage: 'Incorporate dumbbell exercises into your routine to enhance muscle strength, definition, and overall functional fitness.'
  },
  kettlebell: {
    id: 'workoutTagDescriptionMessage.kettlebell',
    defaultMessage: 'Boost your strength and conditioning with kettlebell workouts that combine dynamic movements with resistance training.'
  },
  recovery: {
    id: 'workoutTagDescriptionMessage.recovery',
    defaultMessage: 'Support muscle repair and reduce soreness with recovery-focused workouts, designed to aid in healing and prevent injury.'
  },
  painRelief: {
    id: 'workoutTagDescriptionMessage.painRelief',
    defaultMessage: 'Reduce stiffness with pain-relief workouts, designed to help recovery and release muscle tightness.'
  },
  resistanceBand: {
    id: 'workoutTagDescriptionMessage.resistanceBand',
    defaultMessage: 'Utilize resistance bands to build strength and endurance with low-impact exercises that are gentle on the joints yet highly effective.'
  },
  running: {
    id: 'workoutTagDescriptionMessage.running',
    defaultMessage: 'Enhance your running performance with programs designed to improve speed, stamina, and overall cardiovascular health.'
  },
  mobility: {
    id: 'workoutTagDescriptionMessage.mobility',
    defaultMessage: 'Improve your joint mobility and flexibility with workouts designed to enhance range of motion and reduce injury risk.'
  },
  tabata: {
    id: 'workoutTagDescriptionMessage.tabata',
    defaultMessage: 'Experience maximum intensity in minimal time with Tabata workouts, combining short bursts of effort with brief rest periods for optimal results.'
  },
  kneeSafe: {
    id: 'workoutTagDescriptionMessage.kneeSafe',
    defaultMessage: 'Engage in knee-safe workouts that minimize joint stress while still providing effective strength and conditioning benefits.'
  },
  hipSafe: {
    id: 'workoutTagDescriptionMessage.hipSafe',
    defaultMessage: 'Engage in hip-safe workouts that avoid joint stress while still providing effective strength training benefits.'
  },
  backSafe: {
    id: 'workoutTagDescriptionMessage.backSafe',
    defaultMessage: 'Protect your spine with back-safe workouts that focus on strengthening core muscles and maintaining proper posture.'
  },
  shoulderSafe: {
    id: 'workoutTagDescriptionMessage.shoulderSafe',
    defaultMessage: 'Protect your deltoids with shoulder-safe workouts that focus on strengthening your upper body.'
  },
  senior: {
    id: 'workoutTagDescriptionMessage.senior',
    defaultMessage: 'Gentle and effective workouts for seniors, focusing on maintaining mobility, strength, and balance through low-impact exercises tailored to older adults.'
  },
  trx: {
    id: 'workoutTagDescriptionMessage.trx',
    defaultMessage: 'Build functional strength and stability with TRX suspension training workouts that leverage your bodyweight and gravity to develop core strength, muscular endurance, and balance through dynamic movements.'
  },
  hyrox: {
    id: 'workoutTagDescriptionMessage.hyrox',
    defaultMessage: 'Train for HYROX functional fitness racing with specialized workouts combining running intervals with functional exercises like sled pushes, burpee broad jumps, rowing, and wall balls to build race-specific endurance, strength, and mental toughness.'
  },
  wheelchair: {
    id: 'workoutTagDescriptionMessage.wheelchair',
    defaultMessage: 'Adaptive workouts designed specifically for individuals in wheelchairs, focusing on upper body strength and overall fitness.'
  }
})

export const WORKOUT_TAG_TO_DESCRIPTION_MESSAGE = {
  [WORKOUT_TAG.ALL]: workoutTagDescriptionMessage.all,
  [WORKOUT_TAG.WOMEN]: workoutTagDescriptionMessage.women,
  [WORKOUT_TAG.MEN]: workoutTagDescriptionMessage.men,
  [WORKOUT_TAG.SUMMER]: workoutTagDescriptionMessage.summer,
  [WORKOUT_TAG.CALISTHENICS]: workoutTagDescriptionMessage.calisthenics,
  [WORKOUT_TAG.UPPER]: workoutTagDescriptionMessage.upper,
  [WORKOUT_TAG.ABS]: workoutTagDescriptionMessage.abs,
  [WORKOUT_TAG.LEGS]: workoutTagDescriptionMessage.legs,
  [WORKOUT_TAG.ARMS]: workoutTagDescriptionMessage.arms,
  [WORKOUT_TAG.POWERHYBRID]: workoutTagDescriptionMessage.powerhybrid,
  [WORKOUT_TAG.STRETCHING]: workoutTagDescriptionMessage.stretching,
  [WORKOUT_TAG.FAT_LOSS]: workoutTagDescriptionMessage.fatLoss,
  [WORKOUT_TAG.BEGINNER]: workoutTagDescriptionMessage.beginner,
  [WORKOUT_TAG.INTERMEDIATE]: workoutTagDescriptionMessage.intermediate,
  [WORKOUT_TAG.ADVANCED]: workoutTagDescriptionMessage.advanced,
  [WORKOUT_TAG.LISS]: workoutTagDescriptionMessage.liss,
  [WORKOUT_TAG.HIIT]: workoutTagDescriptionMessage.hiit,
  [WORKOUT_TAG.FULL_BODY]: workoutTagDescriptionMessage.fullBody,
  [WORKOUT_TAG.HOME]: workoutTagDescriptionMessage.home,
  [WORKOUT_TAG.DUMBBELL]: workoutTagDescriptionMessage.dumbbell,
  [WORKOUT_TAG.KETTLEBELL]: workoutTagDescriptionMessage.kettlebell,
  [WORKOUT_TAG.RECOVERY]: workoutTagDescriptionMessage.recovery,
  [WORKOUT_TAG.PAIN_RELIEF]: workoutTagDescriptionMessage.painRelief,
  [WORKOUT_TAG.RESISTANCE_BAND]: workoutTagDescriptionMessage.resistanceBand,
  [WORKOUT_TAG.RUNNING]: workoutTagDescriptionMessage.running,
  [WORKOUT_TAG.MOBILITY]: workoutTagDescriptionMessage.mobility,
  [WORKOUT_TAG.TABATA]: workoutTagDescriptionMessage.tabata,
  [WORKOUT_TAG.KNEE_SAFE]: workoutTagDescriptionMessage.kneeSafe,
  [WORKOUT_TAG.HIP_SAFE]: workoutTagDescriptionMessage.hipSafe,
  [WORKOUT_TAG.BACK_SAFE]: workoutTagDescriptionMessage.backSafe,
  [WORKOUT_TAG.SHOULDER_SAFE]: workoutTagDescriptionMessage.shoulderSafe,
  [WORKOUT_TAG.SENIOR]: workoutTagDescriptionMessage.senior,
  [WORKOUT_TAG.TRX]: workoutTagDescriptionMessage.trx,
  [WORKOUT_TAG.HYROX]: workoutTagDescriptionMessage.hyrox,
  [WORKOUT_TAG.WHEELCHAIR]: workoutTagDescriptionMessage.wheelchair
}

export const WORKOUT_TAG_TO_SEARCH_TERM = {
  [WORKOUT_TAG.WOMEN]: [
    'women',
    'booty',
    'glute'
  ],
  [WORKOUT_TAG.MEN]: [
    'men',
    'for men'
  ],
  [WORKOUT_TAG.SUMMER]: [
    'summer',
    'lean',
    'fat',
    'conditioning'
  ],
  [WORKOUT_TAG.CALISTHENICS]: [
    'calisthenics',
    'bodyweight'
  ],
  [WORKOUT_TAG.FAT_LOSS]: [
    'loss',
    'hiit',
    'cut',
    'burner'
  ],
  [WORKOUT_TAG.UPPER]: [
    'upper',
    'chest',
    'back'
  ],
  [WORKOUT_TAG.ABS]: [
    'abs',
    'ab ',
    'core'
  ],
  [WORKOUT_TAG.LEGS]: [
    'legs',
    'lower',
    'glute'
  ],
  [WORKOUT_TAG.ARMS]: [
    'arms',
    'arm',
    'biceps',
    'triceps'
  ],
  [WORKOUT_TAG.POWERHYBRID]: [
    'powerhybrid'
  ],
  [WORKOUT_TAG.STRETCHING]: [
    'stretch',
    'warmup',
    'mobility'
  ],
  [WORKOUT_TAG.BEGINNER]: [
    'beginner',
    'foundation',
    'start'
  ],
  [WORKOUT_TAG.INTERMEDIATE]: [
    'intermediate'
  ],
  [WORKOUT_TAG.ADVANCED]: [
    'advanced'
  ],
  [WORKOUT_TAG.LISS]: [
    'liss'
  ],
  [WORKOUT_TAG.HIIT]: [
    'hiit'
  ],
  [WORKOUT_TAG.FULL_BODY]: [
    'full body'
  ],
  [WORKOUT_TAG.HOME]: [
    'home',
    'no equipment'
  ],
  [WORKOUT_TAG.DUMBBELL]: [
    'dumbbell',
    'db'
  ],
  [WORKOUT_TAG.KETTLEBELL]: [
    'kettlebell',
    'kb'
  ],
  [WORKOUT_TAG.RECOVERY]: [
    'recovery'
  ],
  [WORKOUT_TAG.PAIN_RELIEF]: [
    'pain relief',
    'pain fix'
  ],
  [WORKOUT_TAG.RESISTANCE_BAND]: ['band'],
  [WORKOUT_TAG.RUNNING]: [
    'couch',
    'run',
    'hybrid'
  ],
  [WORKOUT_TAG.MOBILITY]: [
    'mobility'
  ],
  [WORKOUT_TAG.TABATA]: [
    'tabata'
  ],
  [WORKOUT_TAG.KNEE_SAFE]: [
    'knee safe',
    'knee pain'
  ],
  [WORKOUT_TAG.HIP_SAFE]: [
    'hip safe',
    'hip pain'
  ],
  [WORKOUT_TAG.BACK_SAFE]: [
    'back safe',
    'back pain'
  ],
  [WORKOUT_TAG.SHOULDER_SAFE]: [
    'shoulder safe',
    'shoulder pain'
  ],
  [WORKOUT_TAG.SENIOR]: ['senior'],
  [WORKOUT_TAG.TRX]: [
    'trx',
    'suspension'
  ],
  [WORKOUT_TAG.HYROX]: ['hyrox'],
  [WORKOUT_TAG.WHEELCHAIR]: ['wheelchair']
}

export const WORKOUT_TAG_TO_SEARCH_TERM_TO_AVOID = {
  [WORKOUT_TAG.WOMEN]: PROFILE_GENDER_TO_SEARCH_MALE_QUERY_ARR,
  [WORKOUT_TAG.MEN]: PROFILE_GENDER_TO_SEARCH_FEMALE_QUERY_ARR
}

export const WORKOUT_DEFAULT_TAG_FILTER = 'all'
